import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

/**
 * The Rules Engine admin workspace was merged with Proxy into a single
 * RothRadar™ integration page (see
 * `_app/backoffice/integrations/roth-radar/index.tsx`). This route is kept
 * as a redirect so old links/bookmarks still land in the right place — the
 * `tab` values are identical between the two, so this only has to add
 * `section: 'rules-engine'`.
 */
const tabSchema = z.object({
  tab: z
    .enum(['overview', 'tickers', 'positions', 'alerting', 'rules', 'schedule'])
    .optional()
    .default('overview'),
  ruleId: z.string().optional(),
  runId: z.string().optional(),
  tickerStatus: z
    .enum(['ALL', 'PENDING', 'WARMING_UP', 'ACTIVE', 'DELISTED', 'ERROR'])
    .optional(),
  onlyRecentErrors: z.literal('true').optional(),
})

export const Route = createFileRoute(
  '/_app/backoffice/integrations/rules-engine/',
)({
  validateSearch: tabSchema,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/backoffice/integrations/roth-radar',
      search: {
        section: 'rules-engine',
        tab: search.tab,
        ruleId: search.ruleId,
        runId: search.runId,
        tickerStatus: search.tickerStatus,
        onlyRecentErrors: search.onlyRecentErrors,
      },
    })
  },
})
